module.exports = __webpack_public_path__ + "img/15443784000108.ed57d8fa.png";